import React from 'react';
import classes from './Backdrop.css';

export default props =>
    props.show ? (
        <div className={classes.Backdrop} onClick={props.onClick} />
    ) : null;



// WEBPACK FOOTER //
// ./src/components/Backdrop/Backdrop.js